import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/provider.pb';
import { useTranslation } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { theme } from '@frontend/theme';
import { Avatar, Truncated } from '@frontend/design-system';
import { SETTINGS_TRACKING_IDS } from '../../trackingIds/settings-tracking-ids';
import { VisibilityToggle } from './VisibilityToggle';

export const ProviderNameCell = ({ provider }: { provider: Provider }) => {
  const { t } = useTranslation('scheduleAppointmentTypes');

  const name = getFullName(provider);
  return (
    <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1), width: '100%' }}>
      {provider.isArchived ? (
        <Avatar
          size='small'
          iconName='archive-small'
          title={t('Archived')}
          css={{ svg: { color: theme.colors.icon.subdued } }}
          disableClick
        />
      ) : (
        <Avatar size='small' src={provider.profile?.picUrl} name={name} />
      )}
      <Truncated>{provider.displayName}</Truncated>
    </div>
  );
};

export const ShowOnCalendarCell = ({ provider }: { provider: Provider }) => (
  <VisibilityToggle
    showOnCalendarToggle
    providerDetails={provider}
    value={!provider.hidden}
    disabled={provider.isArchived}
    indeterminate={provider.isArchived}
    trackingId={SETTINGS_TRACKING_IDS.manageProviders.showOnCalendarToggleButton}
  />
);
